// extracted by mini-css-extract-plugin
export default {"box":"Toast_box__jbLY+","tick":"Toast_tick__1ne04","img":"Toast_img__yMpMv","content":"Toast_content__oTnsm","btn":"Toast_btn__TJ6W5"};